import React from 'react';
import { Box, Button, IconButton, Tooltip, Typography, Switch, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

const ControlContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(3),
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

const Group = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
});

const SectionTitle = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.9rem',
  marginRight: '8px',
  color: '#666',
});

const FilterSortControls = ({
  filters,
  setFilters,
  sortBy,
  setSortBy,
  clearAll,
  hideUnranked = false,
  hideAdult = false,
  hidePopularity = false
}) => {
  const handleFilterToggle = (filterName) => {
    setFilters(prev => ({ ...prev, [filterName]: !prev[filterName] }));
  };

  const SortButton = ({ value, children }) => (
    <Button
      variant={sortBy === value ? 'contained' : 'outlined'}
      size="small"
      onClick={() => setSortBy(value)}
    >
      {children}
    </Button>
  );

  return (
    <ControlContainer>
      <Group>
        <SectionTitle>Filter:</SectionTitle>
        {!hideUnranked && (
          <Button
            variant={filters.unrankedOnly ? 'contained' : 'outlined'}
            onClick={() => handleFilterToggle('unrankedOnly')}
            size="small"
          >
            Unranked Only
          </Button>
        )}
        <Tooltip title="Clear filters & sorting">
          <IconButton onClick={clearAll} size="small">
            <FilterListOffIcon />
          </IconButton>
        </Tooltip>
      </Group>

      <Group>
        <SectionTitle>Sort By:</SectionTitle>
        {!hidePopularity && <SortButton value="popularity.desc">Popularity</SortButton>}
        <SortButton value="release_date.desc">Newest</SortButton>
        <SortButton value="release_date.asc">Oldest</SortButton>
        <SortButton value="title.asc">A-Z</SortButton>
        <SortButton value="title.desc">Z-A</SortButton>
        {/* We can add Rating sort buttons here conditionally if needed later, 
            but strictly following "from main page" request for now 
            minus popularity if hidden */}
      </Group>

      {!hideAdult && (
        <FormControlLabel
          control={
            <Switch
              checked={filters.includeAdult}
              onChange={() => handleFilterToggle('includeAdult')}
              name="adultToggle"
            />
          }
          label="Include Adult"
        />
      )}
    </ControlContainer>
  );
};

export default FilterSortControls;